/**
 * Registry-driven label helpers (TMMPDM-0004). Enum values render from the
 * value + the i18n catalog, never from a hardcoded switch — an unmapped value
 * falls through to the raw enum instead of breaking. Add a helper per
 * vocabulary as screens need it; never re-declare a parallel label map in a
 * screen.
 */
export type TFn = (key: string, fallback?: string) => string;

/** saas-auth tenant status: ACTIVE | INACTIVE | SUSPENDED. */
export const tenantStatusLabel = (status: string, t: TFn): string =>
  t(`tenants.status.${status}`, status);
